import { Center, Loader } from '@mantine/core';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useMe } from './session';

/** Strona tylko dla zalogowanych; niezalogowany trafia do logowania i wraca tu po zalogowaniu (US-204 AC-1). */
export function RequireAuth({ children }: { children: ReactNode }) {
  const me = useMe();
  const location = useLocation();
  if (me.isPending) {
    return (
      <Center py="xl">
        <Loader aria-label="Ładowanie" />
      </Center>
    );
  }
  if (!me.data) {
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/logowanie?powrot=${returnTo}`} replace />;
  }
  return children;
}
